import type { StatsType, TopicType } from '@einwert/valuation-api-client'

import { MarketDataCategory, MarketDataCategoryInfo } from 'ClientPortal/src/pages/MarketData/types'
import type { TFunction } from 'i18next'

export const getTimeSeriesStatsTypeLabels = (t: TFunction): Record<StatsType, string> => ({
    maximum: t('stats.maximum'),
    average: t('stats.average'),
    minimum: t('stats.minimum'),
})

export const TimeSeriesStatsTypeColor: Record<StatsType, string> = {
    maximum: '#676767',
    average: '#9E9E9E',
    minimum: '#C4C4C4',
}

export const getTimeSeriesTopicTypeLabels = (t: TFunction): Record<TopicType, string> => ({
    price_apartment_new: t('topics.price_apartment_new'),
    price_apartment_existing: t('topics.price_apartment_existing'),
    rent_apartment_new: t('topics.rent_apartment_new'),
    rent_apartment_existing: t('topics.rent_apartment_existing'),
    price_plot_single_family_house: t('topics.price_plot_single_family_house'),
    price_single_family_house: t('topics.price_single_family_house'),
    price_townhouse_new: t('topics.price_townhouse_new'),
    price_townhouse_existing: t('topics.price_townhouse_existing'),
    retail_rent_city: t('topics.retail_rent_city'),
    retail_rent_1b: t('topics.retail_rent_1b'),
    retail_yield_central: t('topics.retail_yield_central'),
    retail_yield_decentral: t('topics.retail_yield_decentral'),
    office_rent_city: t('topics.office_rent_city'),
    office_rent_fringe: t('topics.office_rent_fringe'),
    office_rent_suburb: t('topics.office_rent_suburb'),
    office_rent_agglomeration: t('topics.office_rent_agglomeration'),
    logistics_rent_logistics: t('topics.logistics_rent_logistics'),
    logistics_rent_service: t('topics.logistics_rent_service'),
    logistics_yield_logistics: t('topics.logistics_yield_logistics'),
    logistics_yield_industrial: t('topics.logistics_yield_industrial'),
    logistics_yield_logistics_prime: t('topics.logistics_yield_logistics_prime'),
    logistics_yield_industrial_prime: t('topics.logistics_yield_industrial_prime'),
    area: t('topics.area'),
    gross_domestic_product: t('topics.gross_domestic_product'),
    gross_domestic_product_ranking: t('topics.gross_domestic_product_ranking'),
    employment: t('topics.employment'),
    unemployment: t('topics.unemployment'),
    unemployment_ranking: t('topics.unemployment_ranking'),
    population: t('topics.population'),
    building_permit_apartments: t('topics.building_permit_apartments'),
    population_density: t('topics.population_density'),
    population_ranking: t('topics.population_ranking'),
    retail_rent_secondary: t('topics.retail_rent_secondary'),
    office_yield_decentral: t('topics.office_yield_decentral'),
    office_yield_central: t('topics.office_yield_central'),
})

export const getTopicCategories = (t: TFunction): Record<MarketDataCategory, MarketDataCategoryInfo> => ({
    apartments: {
        title: t('categories.apartments'),
        defaultForStructures: ['residential', 'mixed'],
        topics: ['price_apartment_new', 'price_apartment_existing', 'rent_apartment_new', 'rent_apartment_existing'],
    },
    houses: {
        title: t('categories.houses'),
        defaultForStructures: ['residential', 'mixed'],
        topics: ['price_plot_single_family_house', 'price_single_family_house', 'price_townhouse_new', 'price_townhouse_existing'],
    },
    office: {
        title: t('categories.office'),
        defaultForStructures: ['office', 'mixed'],
        topics: [
            'office_rent_city',
            'office_rent_fringe',
            'office_rent_suburb',
            'office_rent_agglomeration',
            'office_yield_decentral',
            'office_yield_central',
        ],
    },
    retail: {
        title: t('categories.retail'),
        defaultForStructures: ['retail'],
        topics: ['retail_rent_city', 'retail_rent_1b', 'retail_yield_central', 'retail_yield_decentral', 'retail_rent_secondary'],
    },
    logistics: {
        title: t('categories.logistics'),
        defaultForStructures: ['retail'],
        topics: [
            'logistics_rent_logistics',
            'logistics_rent_service',
            'logistics_yield_logistics',
            'logistics_yield_industrial',
            'logistics_yield_logistics_prime',
            'logistics_yield_industrial_prime',
        ],
    },
    other: {
        title: t('categories.other'),
        defaultForStructures: [],
        topics: [
            'area',
            'gross_domestic_product',
            'gross_domestic_product_ranking',
            'employment',
            'unemployment',
            'unemployment_ranking',
            'population',
            'building_permit_apartments',
            'population_density',
            'population_ranking',
        ],
    },
})
